/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stress scope ratings
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type StressScopeRatingEnum = 'Low' | 'Medium' | 'High' | 'Very High';

export const StressScopeRatingEnum = {
    Low: 'Low' as StressScopeRatingEnum,
    Medium: 'Medium' as StressScopeRatingEnum,
    High: 'High' as StressScopeRatingEnum,
    VeryHigh: 'Very High' as StressScopeRatingEnum
};

marker('Low');
marker('Medium');
marker('High');
marker('Very High');

